import * as React from 'react';
import HintSettingItem from './HintSettingItem';
import { defineMessages } from 'react-intl';
import { intl } from 'i18n';

const messages = defineMessages({
    title: {
        id: 'HintSettings.label',
        defaultMessage: 'Hint'
    },
    description: {
        id: 'HintSettings.description',
        defaultMessage: 'If unsure, a student can check the hint before answering a question.'
    },
    note: {
        id: 'HintSettings.note',
        defaultMessage: 'Note: Hints can be turned off in a question set.'
    },
    btnNewHint: {
        id: 'HintSettings.btnNewHint',
        defaultMessage: '+ Add hint'
    },
    btnAnotherHint: {
        id: 'HintSettings.btnAnotherHint',
        defaultMessage: '+ Add another hint'
    }
})

export default class HintSetting extends React.PureComponent<any, any> {

    render() {
        const { formatMessage } = intl;

        return (
            <div className='lxc-advanced-settings-block'>
                <div className='lxc-advanced-settings-block-title'>
                    {formatMessage(messages.title)}
                </div>
                <div className='lxc-advanced-settings-block-description'>
                    {formatMessage(messages.description)}
                </div>
                <div className='lxc-advanced-settings-form'>
                    {
                        this.props.hints.map((hint: any) => {
                            return (
                                <HintSettingItem key={hint.id} {...hint} hintChange={this.props.hintChange} hintRemove={this.props.hintRemove}/>
                            )
                        })
                    }
                    <button className='lxc-advanced-settings-another-field-btn' type='button' onClick={this.props.hintAdd}>
                        {
                            this.props.hints.length ?
                            formatMessage(messages.btnAnotherHint) :
                            formatMessage(messages.btnNewHint)
                        }
                    </button>
                    <div className='lxc-advanced-settings-note'>
                        {formatMessage(messages.note)}
                    </div>
                </div>
            </div>
        )
    }
};
